module.exports = __webpack_public_path__ + "img/w6-cover.95ed3b1c.jpg";